<template>
    <div class="my_modal" v-bind:class="{show: frameCalculation_Modal_Shown == true}" align="center">
        <div class="my_modal-dialog size-lg">
            <div class="my_modal-content">
                <div class="my_modal-header">
                    <div class="my_fontSize_1Point5 my_fontWeight_600 my_color_00338e ZAfont_family">{{$t('3291')}}</div>
                    <div>
                        <span @click="closeFrameCalculationModalShown" class="fal fa-times fa-2x"></span>
                    </div>
                </div>
                <div class="my_modal-body" style="max-height: calc(100vh - 150px)">
                    <div v-if="propElevatorMotor_Machine_Selection_Shown==true">
                        <div v-if="loader_forLoadingAllContent_at_wrappingAngleCalculation_Modal_Shown==true" align="center">
                            <LoaderIcon v-bind:loaderSize="'lg'"></LoaderIcon>
                        </div>
                        <div v-if="loader_forLoadingAllContent_at_wrappingAngleCalculation_Modal_Shown==false">
                            <div style="display: grid; grid-template-columns: 25% auto; padding: 3px; overflow: auto">
                                <div align="left">
                                    <Images v-if="frame_ImagePath!=null" :imageFilePath="frame_ImagePath" :maxImageHeight="0" :maxImageWidth="0"></Images>
                                </div>
                                <div>
                                    <div v-if="motorData!=null" style="display: grid; grid-template-columns:auto auto; column-gap:10px; align-items:end; justify-items:start;background-color: #f5f5f5">
                                        <span class="ZAfont_family ZAfont_size">{{$t(motorTextKey)}}:</span>
                                        <div style="font-size: 16px; justify-self: end">{{motorData}}</div>
                                    </div>
                                    <div v-if="tractionSheaveData!=null" style="margin-bottom: 10px; display: grid; grid-template-columns:auto auto; column-gap:10px; align-items:end; justify-items:start; background-color: #f5f5f5;">
                                        <span class="ZAfont_family ZAfont_size">{{$t(tractionSheaveTextKey)}}:</span>
                                        <div style="font-size: 16px; justify-self: end">{{tractionSheaveData}}</div>
                                    </div>
                                    <div>
                                        <ul class="my_frame">
                                            <li style="cursor: pointer" v-for="frame in frame_Selection" @click.prevent="change_Selected_at_frame_Selection(frame)" v-bind:class="{active: frame.selected==true}">
                                                <div style="display: grid; grid-template-columns: auto auto auto auto auto auto auto auto; padding: 3px; overflow: auto">
                                                    <div class="my_div_minWidth_100" style="margin-right:10px">
                                                        <div class="my_fontSize_1Point1 ZAfont_family my_color_00338e">
                                                            <span class="my_font-weight_600" v-if="frame.typeDesignation==null || frame.typeDesignation.useTextKey==false">{{frame.frame.typeDesignation}}</span>
                                                            <span class="my_font-weight_600" v-if="frame.typeDesignation!=null && frame.typeDesignation.useTextKey==true">{{$t(frame.typeDesignation.textKey)}}</span>
                                                        </div>
                                                    </div>
                                                    <div class="my_div_minWidth_100 my_div_maginleft_5">
                                                        <div class="my_fontSize_1Point1"><span class="my_font-weight_600">{{frame.frame.type}}</span></div>
                                                        <div class="my_table_parameters_infoText">{{$t('407')}}</div>
                                                    </div>
                                                    <div class="my_div_minWidth_100 my_div_maginleft_5">
                                                        <div class="my_fontSize_1Point1"><span class="my_font-weight_600">{{frame.frame.verticalDistance}}</span> mm</div>
                                                        <div class="my_table_parameters_infoText">{{$t('1026')}}</div>
                                                    </div>
                                                    <div class="my_div_minWidth_100 my_div_maginleft_5">
                                                        <div class="my_fontSize_1Point1"><span class="my_font-weight_600">{{frame.frame.horizontalDistanceMinimum}}</span> mm</div>
                                                        <div class="my_table_parameters_infoText">ASL min</div>
                                                    </div>
                                                    <div class="my_div_minWidth_100 my_div_maginleft_5">
                                                        <div class="my_fontSize_1Point1"><span class="my_font-weight_600">{{frame.frame.horizontalDistanceMaximum}}</span> mm</div>
                                                        <div class="my_table_parameters_infoText">ASL max</div>
                                                    </div>
                                                    <div class="my_div_minWidth_100 my_div_maginleft_5">
                                                        <div class="my_fontSize_1Point1"><span class="my_font-weight_600">{{frame.frame.pulleyDiameter}}</span> mm</div>
                                                        <div class="my_table_parameters_infoText">{{$t('1142')}}</div>
                                                    </div>
                                                    <div class="my_div_minWidth_100 my_div_maginleft_5">
                                                        <div class="my_fontSize_1Point1"><span class="my_font-weight_600">{{frame.frame.dimensionSheet}}</span> </div>
                                                        <div class="my_table_parameters_infoText">{{$t('1193')}}</div>
                                                    </div>
                                                    <div v-if="frame.positionPulleyTextKey != null" class="my_div_minWidth_100 my_div_maginleft_5">
                                                        <div class="my_fontSize_1Point1"><span class="my_font-weight_600"> {{$t(frame.positionPulleyTextKey)}}</span> </div>
                                                        <div class="my_table_parameters_infoText">{{$t('3383')}}</div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div v-if="horizontalDistanceOfTheRopeHoles_Show==true">
                                <div class="ZAfont_family ZAfont_size">{{$t('1026')}}</div>
                                <div class="my_input-group">
                                    <input v-model="verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley" v-bind:placeholder="this.$i18n.i18next.t('3173')" class="my_input" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley_ValidationResult.invalid==true}" disabled />
                                    <div class="my_input-group_unit ZAfont_family">mm</div>
                                </div>
                                <InvalidityReasons v-if="verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley_ValidationResult.invalid" v-bind:validationResult="verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley_ValidationResult"></InvalidityReasons>
                            </div>
                            <div v-if="horizontalDistanceOfTheRopeHoles_Show==true" style="margin-top:10px">
                                <div class="ZAfont_family ZAfont_size">{{$t('1027')}}</div>
                                <div class="my_input-group">
                                    <input v-model="horizontalDistanceOfTheRopeHoles" v-bind:placeholder="this.$i18n.i18next.t('3173')" class="my_input" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: horizontalDistanceOfTheRopeHoles_ValidationResult.invalid==true}" />
                                    <div class="my_input-group_unit ZAfont_family">mm</div>
                                </div>
                                <InvalidityReasons v-if="horizontalDistanceOfTheRopeHoles_ValidationResult.invalid" v-bind:validationResult="horizontalDistanceOfTheRopeHoles_ValidationResult"></InvalidityReasons>
                            </div>
                            <div v-if="horizontalDistanceOfTheRopeHoles_Show==true" style="margin-top:10px">
                                <div class="ZAfont_family ZAfont_size">{{$t('3076')}}</div>
                                <div class="my_input-group">
                                    <input v-model="deflectionPulleyDiameter" v-bind:placeholder="this.$i18n.i18next.t('3173')" class="my_input" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: deflectionPulleyDiameter_ValidationResult.invalid==true}" disabled />
                                    <div class="my_input-group_unit ZAfont_family">mm</div>
                                </div>
                                <InvalidityReasons v-if="deflectionPulleyDiameter_ValidationResult.invalid" v-bind:validationResult="deflectionPulleyDiameter_ValidationResult"></InvalidityReasons>
                            </div>

                            <div v-if="loader_forLoadingResults_at_wrappingAngleCalculation_Modal_Shown==true" align="center">
                                <LoaderIcon v-bind:loaderSize="'lg'"></LoaderIcon>
                            </div>
                            <div v-if="loader_forLoadingResults_at_wrappingAngleCalculation_Modal_Shown==false">
                                <div v-if="(verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley!=null)&&(horizontalDistanceOfTheRopeHoles!=null)&&(deflectionPulleyDiameter!=null)&&(verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley_ValidationResult.invalid==false)&&(horizontalDistanceOfTheRopeHoles_ValidationResult.invalid==false)&&(deflectionPulleyDiameter_ValidationResult.invalid==false)&&(calculated_wrappingAngle!=null)" style="margin-top:10px">
                                    <div class="my_font-weight_600 ZAfont_family ZAfont_size" style="background-color:#f5f5f5; padding:0.75rem; margin-top:10px">{{$t('3294')}}: <span class="my_fontSize_1Point5 my_font-weight_700">{{calculated_wrappingAngle}}&deg;</span></div>
                                </div>
                                <div v-if="(verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley!=null)&&(horizontalDistanceOfTheRopeHoles!=null)&&(deflectionPulleyDiameter!=null)&&(verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley_ValidationResult.invalid==false)&&(horizontalDistanceOfTheRopeHoles_ValidationResult.invalid==false)&&(deflectionPulleyDiameter_ValidationResult.invalid==false)&&(calculated_wrappingAngle==null)" style="margin-top:10px">
                                    <div style="display:grid; grid-template-columns:auto auto; grid-gap:10px; background-color:#cae1ff; padding:0.75rem;">
                                        <div><span class="fal fa-info-square fa-3x my_color_00338e"></span></div>
                                        <div class="ZAfont_family ZAfont_size">
                                            <div>{{$t('3259')}}</div>
                                            <div style="margin-top:10px">{{$t('3258')}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="propElevatorMotor_Machine_Selection_Shown==false">
                        <div style="background-color:#f5f5f5; padding:0.75rem;">
                            <div v-if="frameType_WrappingAngleCalculation != null" style="display: grid; grid-template-columns: auto auto; column-gap: 10px; align-items: end; justify-items: start; margin-top: 7px; background-color: #f5f5f5;">
                                <div class="ZAfont_family ZAfont_size">{{$t('3255')}}: </div>
                                <div style="font-size: 16px; justify-self: end">{{frameTypeDesignation_WrappingAngleCalculation}} {{frameType_WrappingAngleCalculation}}</div>
                            </div>
                            <div v-if="deflectionPulleyDiameter!=null && deflectionPulleyDiameter>0">
                                <div style="display: grid; grid-template-columns: auto auto; column-gap: 10px; align-items: end; justify-items: start;margin-top:7px">
                                    <div class="ZAfont_family ZAfont_size">{{$t('1026')}}:</div>
                                    <div class="ZAfont_family ZAfont_size" style="justify-self:end">{{this.verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley}} mm</div>
                                </div>
                                <div style="display: grid; grid-template-columns:auto auto; column-gap:10px; align-items:end; justify-items:start; margin-top:7px">
                                    <div class="ZAfont_family ZAfont_size">{{$t('1027')}}:</div>
                                    <div class="ZAfont_family ZAfont_size" style="justify-self:end">{{this.horizontalDistanceOfTheRopeHoles}} mm</div>
                                </div>
                                <div style="display: grid; grid-template-columns:auto auto; column-gap:10px; align-items:end; justify-items:start; margin-top:7px">
                                    <div class="ZAfont_family ZAfont_size">{{$t('3076')}}:</div>
                                    <div class="ZAfont_family ZAfont_size" style="justify-self:end">{{this.deflectionPulleyDiameter}} mm</div>
                                </div>
                                <hr />
                                <div style="display: grid; grid-template-columns:auto auto; column-gap:10px; align-items:end; justify-items:start">
                                    <div class="my_font-weight_600 ZAfont_family ZAfont_size">{{$t('3294')}}:</div>
                                    <div class="my_font-weight_600 ZAfont_family ZAfont_size" style="justify-self:end">{{this.calculated_wrappingAngle}} °</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="my_modal-footer" style="justify-content:flex-end">
                    <div>
                        <button v-if="manual==true" @click="closeFrameCalculationModalShown" class="btn my_btn_standard" style="margin-right:5px">{{$t('3090')}}</button>
                        <button v-if="manual==true" @click="changed_frameWrappingAngle" class="btn my_btn_standard" v-bind:disabled="wrappingAngleCalculation_Inputs_Invalid==null||wrappingAngleCalculation_Inputs_Invalid==true">{{$t('1023')}}</button>

                        <button v-if="manual==false&&((propElevatorMotor_Machine_Selection_Shown==false)||((propElevatorMotor_Machine_Selection_Shown==true) && ((loader_forLoadingAllContent_at_wrappingAngleCalculation_Modal_Shown==true) || (loader_forLoadingResults_at_wrappingAngleCalculation_Modal_Shown==true))))" @click="closeFrameCalculationModalShown" class="btn my_btn_standard">{{$t('3090')}}</button>
                        <button v-if="manual==false&&(propElevatorMotor_Machine_Selection_Shown==true) && (loader_forLoadingAllContent_at_wrappingAngleCalculation_Modal_Shown==false) && (loader_forLoadingResults_at_wrappingAngleCalculation_Modal_Shown==false)" @click="show_tractionCheck_Modal" class="btn my_btn_standard">{{$t('1023')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import router from '../../router';
    import LoaderIcon from '../loader/LoaderIcon';
    import InvalidInputs from '../configuration/InvalidInputs'
    import InvalidityReasons from '../dataValidation/InvalidityReasons';
    import Images from '../configuration/Images';
    import { frameModal } from '../../store/frameModal.module';

    export default {
        name: 'FrameModal',

        components: {
            InvalidityReasons,
            LoaderIcon,
            Images,
        },

        props: {
            propElevatorMotor_Machine_Selection_Shown: Boolean,
            manual: Boolean,
            motorData: '',
            tractionSheaveData: '',
            motorTextKey: '',
            tractionSheaveTextKey: '',
        },

        created() {
            this.$store.commit('frameModal/change_manual_storeMutation', this.manual);
            if (this.manual == true) {
                this.$store.dispatch('frameModal/get_frame_Informations_Manual_storeAction');
            }
            else {
                if (this.propElevatorMotor_Machine_Selection_Shown == false || ((this.$store.state.frameModal.frame_Data.hasOwnProperty('frame_Selection')) && (Array.isArray(this.$store.state.frameModal.frame_Data.frame_Selection)) && this.$store.state.frameModal.frame_Data.frame_Selection.length > 0)) {
                }
                else {
                    this.$store.dispatch('driveTechnologies/checkIf_wrappingAngle_withFrameModal_storeAction', this.$store.state.driveTechnologies.elevatorMotor_Machine_forWhich_wrappingAngleCalculation_and_tractionCheck_isMade)
                }
            }
        },

        computed: {
            frameCalculation_Modal_Shown: {
                get() {
                    return true;
                }
            },
            horizontalDistanceOfTheRopeHoles_Show: {
                get() {
                    if ((this.$store.state.frameModal.frame_Data.hasOwnProperty('frame_Selection')) && (Array.isArray(this.$store.state.frameModal.frame_Data.frame_Selection))) {
                        const firstIndexWhere_Selected_atElementOf_frame_Selection_isTrue = this.$store.state.frameModal.frame_Data.frame_Selection.findIndex(i => i.selected == true);
                        if (firstIndexWhere_Selected_atElementOf_frame_Selection_isTrue > - 1) {
                            this.$store.dispatch('frameModal/change_frame_horizontalDistance_Minimum_storeAction', this.$store.state.frameModal.frame_Data.frame_Selection[firstIndexWhere_Selected_atElementOf_frame_Selection_isTrue].frame.horizontalDistanceMinimum);
                            this.$store.dispatch('frameModal/change_frame_horizontalDistance_Maximum_storeAction', this.$store.state.frameModal.frame_Data.frame_Selection[firstIndexWhere_Selected_atElementOf_frame_Selection_isTrue].frame.horizontalDistanceMaximum);
                            if (this.$store.state.frameModal.frame_Data.frame_Selection[firstIndexWhere_Selected_atElementOf_frame_Selection_isTrue].frame.pulleyDiameter == 0) {
                                return false;
                            }
                            else {
                                return true;
                            }
                        }
                        else {
                            return false;
                        }
                    }
                    else {
                        return false;
                    }

                }
            },
            frame_ImagePath: {
                get() {
                    if ((this.$store.state.frameModal.frame_Data.hasOwnProperty('frame_Selection')) && (Array.isArray(this.$store.state.frameModal.frame_Data.frame_Selection))) {
                        const firstIndexWhere_Selected_atElementOf_frame_Selection_isTrue = this.$store.state.frameModal.frame_Data.frame_Selection.findIndex(i => i.selected == true);
                        if (firstIndexWhere_Selected_atElementOf_frame_Selection_isTrue > - 1) {
                            return this.$store.state.frameModal.frame_Data.frame_Selection[firstIndexWhere_Selected_atElementOf_frame_Selection_isTrue].imagePath;
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                }
            },
            frame_Selection: {
                get() {
                    if ((this.$store.state.frameModal.frame_Data.hasOwnProperty('frame_Selection')) && (Array.isArray(this.$store.state.frameModal.frame_Data.frame_Selection))) {
                        return this.$store.state.frameModal.frame_Data.frame_Selection;
                    }
                    else {
                        return [];
                    }
                },

            },

            loader_forLoadingAllContent_at_wrappingAngleCalculation_Modal_Shown: {
                get() {
                    return this.$store.state.frameModal.loader_forLoadingAllContent_at_wrappingAngleCalculation_Modal_Shown;
                },
            },
            loader_forLoadingResults_at_wrappingAngleCalculation_Modal_Shown: {
                get() {
                    return this.$store.state.frameModal.loader_forLoadingResults_at_wrappingAngleCalculation_Modal_Shown;
                },
            },

            wrappingAngle_Calculated: {
                get() {
                    return this.$store.state.frameModal.wrappingAngle_Calculated;
                },
            },

            verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley: {
                get() {
                    const localDecimal = { value: this.$store.state.frameModal.verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley.value, country: this.$store.state.configurations.language, }
                    return this.$get_decimalValueToLocaleString(localDecimal);
                },
                set(value) {
                    const localDecimal = { value: value, country: this.$store.state.configurations.language, name: 'verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley' }
                    this.$store.dispatch('frameModal/set_decimalValue', localDecimal);
                }
            },
            verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley_ValidationResult: {
                get() {
                    return this.$store.state.frameModal.verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley;
                },
            },
            horizontalDistanceOfTheRopeHoles: {
                get() {
                    const localDecimal = { value: this.$store.state.frameModal.horizontalDistanceOfTheRopeHoles.value, country: this.$store.state.configurations.language, }
                    return this.$get_decimalValueToLocaleString(localDecimal);
                },
                set(value) {
                    const localDecimal = { value: value, country: this.$store.state.configurations.language, name: 'horizontalDistanceOfTheRopeHoles' }
                    this.$store.dispatch('frameModal/set_decimalValue', localDecimal);
                }
            },
            horizontalDistanceOfTheRopeHoles_ValidationResult: {
                get() {
                    return this.$store.state.frameModal.horizontalDistanceOfTheRopeHoles;
                },
            },
            deflectionPulleyDiameter: {
                get() {
                    return this.$store.state.frameModal.deflectionPulleyDiameter.value;
                },
                set(value) {
                    this.$store.dispatch('frameModal/change_deflectionPulleyDiameter_storeAction', value);
                }
            },


            deflectionPulleyDiameter_ValidationResult: {
                get() {
                    return this.$store.state.frameModal.deflectionPulleyDiameter;
                },
            },
            calculated_wrappingAngle: {
                get() {
                    return this.$store.state.frameModal.calculated_wrappingAngle;
                },
            },
            wrappingAngleCalculation_Inputs_Invalid: {
                get() {
                    return this.$store.state.frameModal.wrappingAngleCalculation_Inputs_Invalid;
                },
            },
            motorManualDataSelected: {
                get() {
                    if (this.$store.state.inputsManual.motorManualData != null && this.$store.state.inputsManual.motorManualData.hasOwnProperty('details') && this.$store.state.inputsManual.motorManualData.details.hasOwnProperty('mN_MOT')) {
                        return this.$store.state.inputsManual.motorManualData;
                    }
                    return null;
                },
            },
            frameType_WrappingAngleCalculation: {
                get() {
                    if ((this.$store.state.driveTechnologies.elevatorMotor_Machine_Data.hasOwnProperty('elevatorMotor_Machine_Selection')) && (Array.isArray(this.$store.state.driveTechnologies.elevatorMotor_Machine_Data.elevatorMotor_Machine_Selection))) {
                        const firstIndex_whichMeetConditions = this.$store.state.driveTechnologies.elevatorMotor_Machine_Data.elevatorMotor_Machine_Selection.findIndex(i => i.selected == true)
                        if (firstIndex_whichMeetConditions > -1) {
                            const motor = this.$store.state.driveTechnologies.elevatorMotor_Machine_Data.elevatorMotor_Machine_Selection[firstIndex_whichMeetConditions];
                            if (motor.hasOwnProperty('frame')) {
                                if (motor.frame != null && motor.frame.hasOwnProperty('frame')) {
                                    return motor.frame.frame.type;
                                }
                                else {
                                    return null;
                                }
                            }
                            else {
                                return null;
                            }
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
            },
            frameTypeDesignation_WrappingAngleCalculation: {
                get() {
                    if ((this.$store.state.driveTechnologies.elevatorMotor_Machine_Data.hasOwnProperty('elevatorMotor_Machine_Selection')) && (Array.isArray(this.$store.state.driveTechnologies.elevatorMotor_Machine_Data.elevatorMotor_Machine_Selection))) {
                        const firstIndex_whichMeetConditions = this.$store.state.driveTechnologies.elevatorMotor_Machine_Data.elevatorMotor_Machine_Selection.findIndex(i => i.selected == true)
                        if (firstIndex_whichMeetConditions > -1) {
                            const motor = this.$store.state.driveTechnologies.elevatorMotor_Machine_Data.elevatorMotor_Machine_Selection[firstIndex_whichMeetConditions];
                            if (motor.hasOwnProperty('frame')) {
                                if (motor.frame != null && motor.frame.hasOwnProperty('frame')) {
                                    return motor.frame.frame.typeDesignation;
                                }
                                else {
                                    return null;
                                }
                            }
                            else {
                                return null;
                            }
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
            },
            entered_wrappingAngle: {
                get() {
                    const localDecimal = { value: this.$store.state.frameModal.entered_wrappingAngle.value, country: this.$store.state.configurations.language, }
                    return this.$get_decimalValueToLocaleString(localDecimal);
                },
                set(value) {
                    const localDecimal = { value: value, country: this.$store.state.configurations.language, name: 'entered_wrappingAngle' }
                    this.$store.dispatch('frameModal/set_decimalValue', localDecimal);
                }
            },
            entered_wrappingAngle_ValidationResult: {
                get() {
                    return this.$store.state.frameModal.entered_wrappingAngle;
                },
            },

        },
        methods: {
            changed_frameWrappingAngle() {
                this.$store.dispatch('frameModal/get_allFrameDetails_storeAction');
                this.$emit('close');
            },
            closeFrameCalculationModalShown() {
                this.$emit('close');
            },
            change_Selected_at_frame_Selection(value) {
                this.$store.dispatch('frameModal/checkIf_changesAt_frame_changes_configurationFlow_storeAction', value);
            },
            show_tractionCheck_Modal() {
                this.$store.dispatch('driveTechnologies/show_tractionCheck_Modal_storeAction')
            },
        },
    }
</script>
